import { ObjectFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";
import { Col, Row } from "react-bootstrap";

function YouWillProbablyLikeTemplate(
  props: ObjectFieldTemplateProps,
  func: any
) {
  const { actionTemplate } = useUpdateSectionAction();
  return (
    <section className="cms-section">
      <h2 className="cms-section-title">{props.title} {actionTemplate} </h2>
      <div className="cms-section-content">
        <Row>
          <Col sm={6}>
            <div className="property-wrapper">
            {func("you_will_probably_like", props)?.content}
            </div>
          </Col>
          <Col sm={6}>
            <div className="property-wrapper">
            {func("bear_in_mind", props)?.content}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default YouWillProbablyLikeTemplate;
